import React from "react";
import Storage from "./storage.service";
import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import User from "./user.service";
import Products from "./products.service";
import GTMService from "./gtm.service";
import FirebaseAnalytics from "./firebaseAnalytics";

var Numbers = {};

Numbers.per_page = 10;

Numbers.deleteAnyInitialReservations = () => {
    const foundNumbers = Numbers.fetchNumber("1");
    return foundNumbers.then(numberResponse => {
        if (numberResponse.data && numberResponse.data.numbers.length > 0) {
            let number = numberResponse.data.numbers[0];
            return Numbers.cancel(number["MSISDN"])
                .then(res => {
                    Storage.set("selected_number", null);
                    Storage.set("reserved_number_local", null);
                    // Storage.set("should_select_plan", true, true);
                    Storage.clear('MNPSubmitedForm');
                    Storage.clear('chose_mnp');
                    Storage.set("move_to_mnp_otp", false);

                    return User.fetchFlowStatus(1001);
                })
                .catch(error => {
                    Helpers.handleError(error);
                });
        }
    })
        .catch(error => {
            Helpers.handleError(error);
        });
};


Numbers.getNumberPart = (number) => {
    if ((number + "").length === 11)
        return " " + number.slice(3, 5) + "" + number.slice(5);
    if ((number + "").length === 8)
        return " " + number.slice(0, 2) + "" + number.slice(2);
    if ((number + "").length === 9)
        return " " + number.slice(1, 3) + "" + number.slice(3);

    return number;
};

Numbers.MakeWarningModal = (labels, actions, loading = false, comp = null) => {
    let warningModal = (
        <div className="number-warning-modal">
            <div className="modal-content">
                <div className="modal-text-title">{labels.title}</div>
                <div className="modal-text-message">
                    {labels.message}
                </div>
                {loading ? comp : <div className="modal-btns">
                    <button
                        id="btn_leave_number_yes"
                        className="btn btn-primary"
                        // onClick={() => {
                        //  Numbers.deleteAnyInitialReservations();
                        // }}
                        onClick={() => {
                            actions.mainAction();
                            // Numbers.deleteAnyInitialReservations();
                        }}
                    >
                        {labels.mainBtn}
                    </button>
                    <button
                        className="btn btn-secondary"
                        id="btn_leave_number_no"
                        onClick={actions.close}
                    >
                        {labels.closeBtn}
                    </button>
                </div>}
            </div>
        </div>
    );

    return warningModal;
};

Numbers.fetchMnpOperators = () => {
    let config = {
        method: "get",
        url: "/mnp/available_operators"
    };
    return HTTP(config);

    // Success response
    //  [
    //   {
    //     "Id": 1,
    //     "Operator": "STC"
    //   },
    //   {
    //     "Id": 2,
    //     "Operator": "Lebara"
    //   },
    //   {
    //     "Id": 3,
    //     "Operator": "Mobily"
    //   },
    //   {
    //     "Id": 4,
    //     "Operator": "Zain"
    //   }
    // ]
};

// HasPendingMNPApproval
// IsMnp

Numbers.getVanityId = async () => {
    let vanity_id = Storage.get("vainity_id");
    if (vanity_id) {
        return vanity_id;
    } else {
        let dataVanity = await Numbers.vanity_details()
        if (dataVanity["data"]) {
            let vanity_id = [];
            let vanity_details = [];
            for (let vanity of dataVanity?.data) {
                vanity["vanityPrice"] = vanity["Price"];
                if (vanity?.VanityID || vanity?.VanityID === 0) {
                    vanity_id.push(vanity.VanityID)
                }
            }
            vanity_id = vanity_id?.length ? vanity_id?.sort() : vanity_id;
            vanity_details = Helpers.arrayToKeyedObject(dataVanity?.data, "VanityID");
            Storage.set("vanity_details", vanity_details)
            Storage.set("vainity_id", vanity_id.toString())
            return vanity_id.toString();
        }
        return
    }
};

Numbers.checkMnpStatus = () => {
    //@Todo get mnp number from api
    let data = JSON.parse(Storage.get("mnp_info", true));
    // console.log(data);
    let number = null;
    if (data) {
        number = data["mnp_number"];
    } else {
        data = Storage.get("reserved_number");
        // console.log(data);
        if (data && data["MSISDN"]) {
            number = data["MSISDN"];
        }
    }

    if (number) {
        number = Helpers.getNumberWithCountryCode(number);
    }

    let config = {
        method: "get",
        url: "/mnp/check_status?number=" + number + "&random=" + Date.parse(new Date())
    };
    return HTTP(config);
};

Numbers.requestMnpOtp = () => {
    return Numbers.getMnpOtp()
        .then(res => {
            return res
        })
        .catch(err => {
            // clear stuff to go back to mnp form
            Storage.clear("move_to_mnp_otp");
            // Storage.clear("mnp_info");

            throw err
        });
};

Numbers.getMnpOtp = () => {

    let data = JSON.parse(Storage.get("mnp_info", true));

    if (data && data["mnp_number"]) {
        let config = {
            method: "get",
            url: "/mnp/request_otp?number=" + data["mnp_number"] + "&random=" + Date.parse(new Date())
        };
        return HTTP(config);
    }

};

Numbers.portInMyNumber = () => {
    Numbers.deleteAnyInitialReservations()
        .then(() => {
            // console.log("Deleted reservation ... ")
            setTimeout(() => {
                // console.log("Set chose_mnp to true ... ")

                const data = Storage.get("flags")
                data.chose_mnp = true;
                Storage.set("flags", data);
                Storage.set("chose_mnp", true, true);
            }, 100)

        })
}


Numbers.keepMnpRequestInfo = form => {
    // console.log("keepMnpRequestInfo ", form);

    let data = {};
    // data["otp"] = "";
    data["operator_id"] = form.operator_id.value;
    if (form.contact_number.value.trim().length) {
        data["contact_number"] = form.country_select.iso + '' + form.contact_number.value;
    }
    else {
        data["contact_number"] = Helpers.getNumberWithCountryCode(form.mnp_number.value);
    }

    data["mnp_number"] = Helpers.getNumberWithCountryCode(form.mnp_number.value);

    // console.log(data);


    Storage.set("mnp_info", JSON.stringify(data), true);
};

Numbers.submitMnpRequestAndNext = form => {
    return new Promise((resolve) => {
        Numbers.submitMnpRequest(form)
            .then(res => {
                let firebase_param = {
                    item_name: "number",
                    item_variant: "mnp",
                    item_category: "mnp",
                }
                FirebaseAnalytics.number_selected(firebase_param);
                FirebaseAnalytics.updateUser({ type: "mnp" });
                // console.log(res);
                Storage.set("chose_mnp", false, true);
                User.fetchFlowStatus(12222);
                resolve(true)
            })
            .catch(err => {
                resolve(false)
                // Storage.clear("mnp_info");
                // Storage.clear("chose_mnp");
            });
    })
};

Numbers.submitMnpRequest = form => {
    // console.log("submitMnpRequest ", form);

    let data = JSON.parse(Storage.get("mnp_info", true));
    if (data) {
        data["otp"] = form.otp.value;
    }

    // console.log(data);

    let config = {
        method: "post",
        url: "/mnp/submit_request",
        data: data
    };

    return HTTP(config);
};

Numbers.fetchNumber = (reservation_ids = "1,3,4,5", callee = "default") => {
    let config = {
        method: "get",
        url: "/numbers?reservation_ids=" + reservation_ids + "&random=" + Date.parse(new Date())
    };
    return HTTP(config);
};

Numbers.fetchNumberByReservationType = (reservation_ids = "1") => {
    //reserv_type possbile values are: initial=1, commit=3, cancel=4, autoCancel=5, termination=8,activated=9, initialToChangeNumber=10, MNPInitial=11
    let config = {
        method: "get",
        url: "/numbers/reservation?reservation_types=" + reservation_ids + "&random=" + Date.parse(new Date())
    };
    return HTTP(config);
};

Numbers.getNumber = (callee = "default") => {
    let number = null;
    Helpers.log("Numbers.getNumber");
    return Storage.getOrfetch("reserved_number", Numbers.fetchNumber)
        .then(response => {
            if (response["data"]) {
                if (response["data"]["numbers"][0]) {
                    number = response["data"]["numbers"][0];
                    Storage.set("reserved_number", number);
                    Storage.set("reserved_number_local", JSON.stringify(number), true);
                } else {
                    number = null;
                }
                Storage.set("reserved_number", number);
                Storage.set("reserved_number_local", JSON.stringify(number), true);
                return number;
            } else {
                number = response;

                if (response) {
                    Storage.set("reserved_number", number);
                    Storage.set("reserved_number_local", JSON.stringify(number), true);
                }
                return number;
            }
        })
        .catch(error => { });
};

Numbers.startSearch = (fragment, append = true) => {
    let page = 1;

    if (append) {
        page = Storage.get("search_page") + 1;
    }
    let vanities = Storage.get("active_search_vanity");
    if ((!vanities && vanities !== 0) || vanities === "all") {
        vanities = Object.keys(Storage.get("vanity_details")).join(",");
    }

    Storage.set("searching_for_numbers", true);
    Storage.set("appending_search_results", append);
    Storage.set("search_page", page);
    Storage.set("last_search_fragment", fragment);
    if (fragment) {
        let firebase_param = {
            search_term: fragment
        }
        FirebaseAnalytics.search_executed(firebase_param);
    }

    Numbers.search(fragment, vanities)
        .then(response => {
            if (response.data) {
                let initial = Storage.get("search_numbers_result");
                let no_match = Storage.get("search_numbers_no_match");
                if (!append) {
                    initial = [];
                    if (response.data.is_recommended_number) {
                        if (page === 1) {
                            no_match = true;
                        }
                    } else {
                        no_match = response.data.is_recommended_number;
                    }
                }

                Storage.set("search_numbers_no_match", no_match);
                Storage.set("search_numbers_latest", response.data);
                Storage.set("searching_for_numbers", false);
                Storage.set(
                    "search_numbers_result",
                    initial.concat(response.data.numbers)
                );
            }
        })
        .catch(error => {
            // this.setState({
            // searching: false,
            // appending: false
            // });
        });
};

Numbers.getNumberDetailsFromVanity = number => {
    let VanityLevel = Numbers.getVanityLevelID(number);

    let vanity_details = Storage.get("vanity_details");
    return vanity_details["" + VanityLevel];
};

Numbers.get_number_pieces = (msisdn, vanity, fragment = "", color = "") => {
    if (msisdn.slice(0, 3) === "966") {
        msisdn = "0" + msisdn.substring(3, msisdn.length);
    }

    let msisdn1 = msisdn.slice(0, 3);
    let msisdn2 = msisdn.slice(3);
    let number_html = <></>;
    if (color) {
        number_html = (
            <span className={"number-pieces has-type"}>
                <span className="prefix" style={color}>{msisdn1}</span>
                {msisdn2}
            </span>
        );
    } else {
        number_html = (
            <span className={"number-pieces has-type"}>
                <span className="prefix">{msisdn1}</span>
                {msisdn2}
            </span>
        );
    }

    if (fragment && msisdn2.indexOf(fragment) !== -1) {
        let split = msisdn2.split(fragment);
        number_html = [];
        number_html.push(
            <span key={"ve" + Math.random()}>
                <span className="prefix" style={color}>{msisdn1}</span>
            </span>
        );
        for (let piece in split) {
            number_html.push(
                <span key={msisdn2 + "1" + Math.random()}>{split[piece]}</span>
            );
            if (piece < split.length - 1) {
                number_html.push(
                    <span className="highlight" key={msisdn2 + "2" + Math.random()}>
                        {fragment}
                    </span>
                );
            }
        }
    }

    return number_html;
};

Numbers.search = (fragment, vanity_level_ids) => {
    let data = {};
    data["per_page"] = Numbers.per_page; //* Storage.get("search_page");
    data["page"] = Storage.get("search_page");
    data["pattern"] = fragment;
    data["vanity_level_ids"] = vanity_level_ids;

    let config = {
        method: "post",
        url: "/numbers/search",
        data: data
    };

    return HTTP(config);
};

Numbers.selectNumber = number => {
    Helpers.log("Numbers.selectNumber()", number);
    Storage.set("selected_number", number);
};

Numbers.vanity_details = () => {
    let config = {
        method: "get",
        url: "/numbers/vanity_details"
    };
    return HTTP(config);
};

Numbers.storage_checks = () => {
    if (Storage.get("search_page") === null) {
        Storage.set("search_page", 1);
    }

    if (Storage.get("filter_vip") === null) {
        Storage.set("filter_vip", false);
    }

    if (Storage.get("number_search_fragment") === null) {
        Storage.set("number_search_fragment", "");
        Storage.set("last_search_fragment", "");
    }

    if (Storage.get("search_numbers_no_match") === null) {
        Storage.set("search_numbers_no_match", false);
    }

    if (Storage.get("search_numbers_result") === null) {
        Storage.set("search_numbers_result", []);
    }
};

Numbers.process_vanity_details = data => {
    for (let vanity of data) {
        vanity["vanityPrice"] = vanity["Price"];
    }

    let processed = Helpers.arrayToKeyedObject(data, "VanityID");
    let processed_by_price = Helpers.arrayToKeyedObject(data, "Price");

    Storage.set("vanity_details", processed);
    Storage.set("vanity_details_by_price", processed_by_price);

    let keys = Object.keys(processed);
    let all = keys.join(",");
    if (Storage.get("active_search_vanity") === null) {
        Storage.set("active_search_vanity", all);
    }
};

Numbers.unselectNumber = () => {
    Storage.set("selected_number", null);
};

// Numbers.reserveNumberFromParams = number => {

//  Numbers.fetchNumber("1")
//      .then(numberResponse => {
//          if (numberResponse.data && numberResponse.data.numbers.length > 0) {
//              let number = numberResponse.data.numbers[0];

//              Numbers.cancel(number["MSISDN"])
//              .then(res => {
//                  Numbers.reserveNumber(number);
//              })
//              .catch(error => {
//                  // Helpers.handleError(error);
//              });

//          } else {
//              Numbers.reserveNumber(number);
//          }
//      })
//      .catch(error => {
//          // Helpers.handleError(error);
//      });
// };

Numbers.getVanityLevelID = number => {
    let id =
        number?.VanityLevel || number?.VanityLevel === 0
            ? number?.VanityLevel
            : number?.VanityLevelId;
    id =
        number?.VanityLevelID || number?.VanityLevelID === 0
            ? number?.VanityLevelID
            : id;

    return id;
};

Numbers.postProcessReservedNumber = (ids = "1") => {
    let f = Numbers.fetchNumber(ids);
    f
        .then(numberResponse => {
            // console.log("numberResponse", numberResponse);
            if (numberResponse["data"] && numberResponse["data"]["numbers"][0]) {
                let number = numberResponse["data"]["numbers"][0];
                let VanityLevel = Numbers.getVanityLevelID(number);
                Storage.set("number_selected_flow_vanity_id", VanityLevel);
                Storage.set("number_VanityLevel", VanityLevel);
                Storage.set("reserving_number", false);
                Storage.set("reserved_number", number);
                Storage.set("reserved_number_local", JSON.stringify(number), true);
                Storage.set("selected_number", null);
                GTMService.action_on_book_your_number_click_on_cta();
            }
        })
        .catch(err => {
            // console.log("hana");
        });

    return f;
};

Numbers.reserveNumber = number => {
    Storage.set("reserving_number", true);
    Storage.set("PredefinedPlansWithVanity", null);

    Numbers.postNumber(number.MSISDN)
        .then(response => {
            Products.saveCurrentProduct()
                .then(resp => {
                    let VanityLevel = Numbers.getVanityLevelID(number);
                    if (!VanityLevel) {
                        Numbers.fetchNumber("1")
                            .then(numberResponse => {
                                if (
                                    numberResponse["data"] &&
                                    numberResponse["data"]["numbers"][0]
                                ) {
                                    let number = numberResponse["data"]["numbers"][0];
                                    VanityLevel = Numbers.getVanityLevelID(number);

                                    Storage.set("number_selected_flow_vanity_id", VanityLevel);
                                    Storage.set("number_VanityLevel", VanityLevel);

                                    GTMService.action_on_book_your_number_click_on_cta();

                                    User.fetchFlowStatus(12)
                                        .then(resp => {
                                            // console.log("fetched")
                                            Storage.set("reserving_number", false);
                                            Storage.set("reserved_number", number);
                                            Storage.set("reserved_number_local", JSON.stringify(number), true);
                                            Storage.set("selected_number", null);
                                        })
                                        .catch(err => { });
                                }
                            })
                            .catch(err => { });
                    } else {
                        let VanityLevel = Numbers.getVanityLevelID(number);
                        Storage.set("number_selected_flow_vanity_id", VanityLevel);
                        Storage.set("number_VanityLevel", VanityLevel);

                        GTMService.action_on_book_your_number_click_on_cta();

                        User.fetchFlowStatus(12)
                            .then(resp => {
                                // console.log("fetched")
                                Storage.set("reserving_number", false);
                                Storage.set("reserved_number", number);
                                Storage.set("reserved_number_local", JSON.stringify(number), true);
                                Storage.set("selected_number", null);
                            })
                            .catch(err => { });
                    }
                })
                .catch(error => { });
        })
        .catch(error => {
            Storage.set("reserving_number", false);
        });
};

Numbers.postNumber = MSISDN => {
    Helpers.log("Numbers.postNumber()", MSISDN);

    let data = {};
    data["number"] =
        //"971" +
        MSISDN;
    //.substr(1)

    let config = {
        method: "post",
        url: "/numbers",
        data: data
    };
    return HTTP(config);
};

Numbers.getNumberStats = () => {
    let config = {
        method: "get",
        url: "/numbers",
    };
    return HTTP(config);
};

Numbers.isPremiumNumber = number => {
    let details = Numbers.getNumberDetailsFromVanity(number);
    if (details["vanityPrice"] > 0) {
        return true;
    } else {
        return false;
    }
};

Numbers.cancel = MSISDN => {
    let data = {};
    data["number"] =
        //"0" +
        MSISDN;
    //.substr(3)

    let config = {
        method: "delete",
        url: "/numbers",
        data: data
    };
    return HTTP(config);
};

Numbers.mnpCancel = (MSISDN) => {
    let data = {};
    data["number"] = MSISDN;
    let config = {
        method: "post",
        url: "/mnp/cancel",
        data: data,
    };
    return HTTP(config);
};

Numbers.getRandomNumber = (is_family = false) => {
    let config = {
        method: "post",
        url: "/numbers/random",
        data: {
            is_family,
        },
    };
    return HTTP(config);
};

Numbers.confirmRandomNumber = (params) => {
    let config = {
        method: "post",
        url: "/numbers/random_confirmation",
    };
    return HTTP(config);
};

Numbers.postProcessCommitedNumber = (ids = "2") => {
    let f = Numbers.fetchNumber(ids);
    f.then((numberResponse) => {
        // console.log("numberResponse", numberResponse);
        if (numberResponse["data"] && numberResponse["data"]["numbers"][0]) {
            let number = numberResponse["data"]["numbers"][0];
            let VanityLevel = Numbers.getVanityLevelID(number);
            Storage.set("number_selected_flow_vanity_id", VanityLevel);
            Storage.set("number_VanityLevel", VanityLevel);
            Storage.set("reserving_number", false);
            Storage.set("get_commiting_number", false);
            Storage.set("reserved_number_local", null);
            Storage.set("selected_number", null);
            Storage.set("commited_number", numberResponse["data"]["numbers"][0]);
            //  GTMService.action_on_book_your_number_click_on_cta();
        }
    }).catch((err) => {
        // console.log("hana");
    });

    return f;
};

export default Numbers;

